import React, { useEffect } from "react";
import styled from "styled-components";
import { bool } from "prop-types";
import {
  paginatedFormSubmit,
  standardFormSubmit
} from "data/segmentCustomEvents";
import Copy from "components/shared/Copy";
import { SuccessIcon } from "components/icons/index";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    min-height: 400px;
  }
`;

const SuccessPage = ({ standard }) => {
  useEffect(() => {
    if (standard) {
      standardFormSubmit();
    } else {
      paginatedFormSubmit();
    }
  }, []);
  return (
    <Wrapper>
      <Copy color="darkBlue" size={1} weight="600">
        Success!
      </Copy>
      <Copy margin="1rem auto" size={0.8} width="250px">
        We are now taking you to your care hub, where we will ask for some more
        information specific to your care requirements
      </Copy>
      <SuccessIcon />
    </Wrapper>
  );
};

SuccessPage.propTypes = {
  standard: bool
};

export default SuccessPage;
